import { create } from "zustand";

interface FormState {
    ID: boolean,
    fullname: boolean,
}

const useForm = create<FormState>()((set) => ({
    ID: false,
    fullname: false
}));

export default useForm;
